<template>
  <ProductContentDetails
    :offer="offer"
    headline="Technische Details"
    class="feature-list"
  >
    <template #default="slotProps">
      <Charger
        v-if="slotProps.product?.commonCharger?.possible"
        class="feature-list__charger"
        :common-charger="slotProps.product.commonCharger"
      />
      <TechnicalDetails
        v-if="slotProps.product"
        :features="getFeatures(slotProps.product)"
        :documents="documents"
      />
    </template>
  </ProductContentDetails>
</template>

<script setup lang="ts">
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import TechnicalDetails from '~/components/product-detail/tabs/technical-details.vue';
import { Charger } from '@i22team/td-longtail-vue-components';

export type FeatureListProps = {
  offer?: Offer;
};

const props = withDefaults(defineProps<FeatureListProps>(), {
  offer: undefined,
});

// documents are on the Offer, features on the Product!
const documents = computed(() => (props.offer?.documents || []).filter(Boolean));

export type Feature = { name: string; value: string };

const getValue = (val: string) => {
  if (val === 'false') return 'Nein';
  if (val === 'true') return 'Ja';
  return val;
};

const getFeatures = (product: OfferProduct): Feature[] => {
  const features: Feature[] = [];
  if (product.eans) {
    features.push({
      name: 'GTIN',
      value: product.eans.join(', '),
    });
  }

  const standardProduct: OfferStandardProduct | undefined =
    getStandardProduct<OfferProduct>(product) ?? undefined;
  if (standardProduct) {
    standardProduct.features?.forEach((f) => {
      if (f?.name && f.value !== undefined && f.value !== null) {
        features.push({
          name: f.name,
          value: getValue(f.value),
        });
      }
    });
  }

  return features;
};
</script>

<style lang="scss" scoped>
.feature-list {
  &__charger {
    font-size: 5em;
  }
}
</style>
